import graphqlClient from "../../../apollo";

class FacturacionProvider {

    // Facturas
    paginateFacturas(pageNumber, itemsPerPage, search = null, filters = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/facturaPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, filters, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    getFacturasPendientes(companyId) {
        return graphqlClient.query({
            query: require('./gql/facturasPendientes.graphql'),
            variables: { companyId },
            fetchPolicy: "network-only"
        })
    }

    getFacturaExistePorMovimiento(movimientoId) {
        return graphqlClient.query({
            query: require('./gql/facturaExistePorMovimiento.graphql'),
            variables: { movimientoId },
            fetchPolicy: "network-only"
        })
    }

    getFacturasExistenPorMovimientos(movimientoIds) {
        return graphqlClient.query({
            query: require('./gql/facturasExistenPorMovimientos.graphql'),
            variables: { movimientoIds },
            fetchPolicy: "network-only"
        })
    }

    emitirFactura(movimientoId, clienteId, tipoComprobante, email, origen, ordenVentaId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaEmitir.graphql'),
            variables: { movimientoId, clienteId, tipoComprobante, email, origen, ordenVentaId }
        })
    }

    marcarFacturaPendiente(movimientoId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaMarcarPendiente.graphql'),
            variables: { movimientoId }
        })
    }

    fetchFactura(id) {
        return graphqlClient.query({
            query: require('./gql/facturaFetch.graphql'),
            variables: { id },
            fetchPolicy: "network-only"
        })
    }

    generarPDF(facturaId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaGenerarPDF.graphql'),
            variables: { facturaId }
        })
    }

    generarPDFBase64(facturaId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaGenerarPDFBase64.graphql'),
            variables: { facturaId }
        })
    }

    enviarEmail(facturaId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaEnviarEmail.graphql'),
            variables: { facturaId }
        })
    }

    reintentarFactura(facturaId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaReintentar.graphql'),
            variables: { facturaId }
        })
    }

    procesarPendientes(companyId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturaProcesarPendientes.graphql'),
            variables: { companyId }
        })
    }

    facturaDownloadToken(facturaId) {
        return graphqlClient.query({
            query: require('./gql/facturaDownloadToken.graphql'),
            variables: { facturaId },
            fetchPolicy: "network-only"
        })
    }

    consultarComprobanteAfip(facturaId) {
        return graphqlClient.query({
            query: require('./gql/facturaComprobanteAfipInfo.graphql'),
            variables: { facturaId },
            fetchPolicy: "network-only"
        })
    }

    // ---- Facturación masiva ----

    facturacionMasivaCola(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false, filters = null) {
        return graphqlClient.query({
            query: require('./gql/facturacionMasivaCola.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc, filters },
            fetchPolicy: "network-only"
        })
    }

    facturacionMasivaResumen(filters = null) {
        return graphqlClient.query({
            query: require('./gql/facturacionMasivaResumen.graphql'),
            variables: { filters },
            fetchPolicy: "network-only"
        })
    }

    // network-only es obligatorio acá: con la cache de Apollo el polling
    // devolvería siempre el mismo progreso.
    facturacionMasivaLote(id) {
        return graphqlClient.query({
            query: require('./gql/facturacionMasivaLote.graphql'),
            variables: { id },
            fetchPolicy: "network-only"
        })
    }

    facturacionMasivaLoteActivo() {
        return graphqlClient.query({
            query: require('./gql/facturacionMasivaLoteActivo.graphql'),
            fetchPolicy: "network-only"
        })
    }

    facturacionMasivaEmitir(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturacionMasivaEmitir.graphql'),
            variables: { input }
        })
    }

    facturacionMasivaReintentar(loteId, ordenVentaIds = null) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturacionMasivaReintentar.graphql'),
            variables: { loteId, ordenVentaIds }
        })
    }

    facturacionMasivaCancelar(loteId) {
        return graphqlClient.mutate({
            mutation: require('./gql/facturacionMasivaCancelar.graphql'),
            variables: { loteId }
        })
    }

}

export default new FacturacionProvider()
